<template>
	<div class="customers-viewer">
		<ModalHeader :title="getString('customer_details')" />
		<div class="loader-container" v-if="loading">
			<AppLoader />
		</div>
		<div class="customer-container" v-else>
			<AppList :items="customerType === 'person' ? customerPersonItems : customerCompanyItems" />
		</div>
	</div>
</template>

<script>
import {useCustomersStore, useUserStore} from "@/console-new/stores";
import ModalHeader from "@/console-new/components/shared/ModalHeader.vue";
import AppLoader from "@/shared/components/AppLoader.vue";
import {useLanguageStore, useNotificationStore} from "@/shared/stores";
import API from "@/shared/helpers/API";
import AppList from "@/shared/components/AppList.vue";
import AppButton from "@/shared/components/AppButton.vue";
import {formatDateMMDDHHmm} from "@/shared/helpers/dates";

export default {
	setup() {
		const languageStore = useLanguageStore();
		const userStore = useUserStore();
		const customersStore = useCustomersStore();
		const notificationStore = useNotificationStore();
		return {userStore, getString: languageStore.getString, notificationStore, customersStore}
	},
	components: {AppButton, AppList, AppLoader, ModalHeader},
	name: "CustomersViewer",
	emits: ['customer-not-found'],
	props: {
		customerId: {
			type: Number,
			default: null
		},
		customerType: {
			type: String,
			default: null
		},
	},
	data() {
		return {
			customer: null,
			loading: false,
		}
	},
	computed: {
		customerPersonItems() {
			return [
				{
					title: this.getString("customer_name"),
					rightText: this.customer ? this.customer.name : "-",
					rightPrimaryText: true,
					leftGreyText: true,
				},
				{
					title: this.getString("phone"),
					rightText: this.customer && this.customer.phone ? this.customer.phone : "-",
					rightPrimaryText: true,
					leftGreyText: true,
				},
				{
					title: this.getString("email"),
					rightText: this.customer && this.customer.email ? this.customer.email : "-",
					rightPrimaryText: true,
					leftGreyText: true,
				},
				{
					title: this.getString("address"),
					rightText: this.customer && this.customer.address ? this.customer.address : "-",
					rightPrimaryText: true,
					leftGreyText: true,
				},
				{
					title: this.getString("fiscal_code"),
					rightText: this.customer && this.customer.fiscal_code ? this.customer.fiscal_code : "-",
					rightPrimaryText: true,
					leftGreyText: true,
				},
				{
					title: this.getString("birth_date"),
					rightText: this.customer && this.customer.birth_date ? formatDateMMDDHHmm(this.customer.birth_date) : "-",
					rightPrimaryText: true,
					leftGreyText: true,
				},
				{
					title: this.getString("gender"),
					rightText: this.customer && this.customer.gender ? this.getString(this.customer.gender) : "-",
					rightPrimaryText: true,
					leftGreyText: true,
				},
				{
					title: this.getString("customer_notes"),
					rightText: this.customer && this.customer.notes ? this.customer.notes : "-",
					rightPrimaryText: true,
					leftGreyText: true,
				},
			];
		},
		customerCompanyItems() {
			return [
				{
					title: this.getString("customer_name"),
					rightText: this.customer ? this.customer.name : "-",
					rightPrimaryText: true,
					leftGreyText: true,
				},
				{
					title: this.getString("vat"),
					rightText: this.customer ? this.customer.vat : "-",
					rightPrimaryText: true,
					leftGreyText: true,
				},
				{
					title: this.getString("sdi"),
					rightText: this.customer ? this.customer.sdi : "-",
					rightPrimaryText: true,
					leftGreyText: true,
				},
				{
					title: this.getString("address"),
					rightText: this.customer && this.customer.address ? this.customer.address : "-",
					rightPrimaryText: true,
					leftGreyText: true,
				},
				{
					title: this.getString("pec"),
					rightText: this.customer && this.customer.pec ? this.customer.pec : "-",
					rightPrimaryText: true,
					leftGreyText: true,
				},
				{
					title: this.getString("fiscal_code"),
					rightText: this.customer && this.customer.fiscal_code ? this.customer.fiscal_code : "-",
					rightPrimaryText: true,
					leftGreyText: true,
				},
				{
					title: this.getString("customer_notes"),
					rightText: this.customer && this.customer.notes ? this.customer.notes : "-",
					rightPrimaryText: true,
					leftGreyText: true,
				},
			];
		},
	},
	methods: {
		loadCustomer() {
			if (this.customerId) {
				this.loading = true;

				API.init().getCustomer(this.userStore.currBusinessId, this.customerId, this.customerType, r => {
					this.loading = false;
					if(r && r.result && r.result === "OK") {
						this.customer = this.customersStore[this.customerType === 'person' ? 'normalizeCustomerPerson' : 'normalizeCustomerCompany'](r.customer);
					} else {
						this.customer = null;
						this.notificationStore.showNotification("warning-customer-missing");
						this.$emit('customer-not-found');
					}
				});
			}
		}
	},
	mounted() {
		this.loadCustomer();
	},
	watch: {
		customerId() {
			this.loadCustomer();
		}
	},
}
</script>

<style scoped lang="scss">
.loader-container {
	display: flex;
	justify-content: center;
	align-items: center;
	padding: 5px;
}
</style>